import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {CardLog} from "../models/cardLog";

@Injectable({ providedIn: 'root' })
export class CardLogService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    findCardLogs(uuid: string) {
        return this.http.get<CardLog[]>(`${environment.apiEndpoint}/v1/card/logs/` + uuid, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    findCardErrorLogs(uuid: string) {
        return this.http.get<CardLog[]>(`${environment.apiEndpoint}/v1/card/error-logs/` + uuid, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
